import React from "react";

/**
 * Renders rich HTML saved from the TipTap editor.
 * Pass the saved HTML through as-is — do not wrap/unwrap inner nodes.
 */
const RichHtml = ({ html, className = "", style }) => {
  if (!html?.trim()) return null;

  return (
    <div
      className={`tiptap-content ${className}`.trim()}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichHtml;
